window.jQuery = require('jquery');

import Cart from './modules/cart';

new Cart();



// WEBPACK FOOTER //
// ./src/js/app.js